// TelcoTrack — Ukončení v RD (Specifikace závrtů u milníku ZAVRTANY, Připojená BUDOVA).

export const UKONCENI_V_RD_VALUES = [
  'OBYTNY_PROSTOR',
  'GARAZ',
  'SERVEROVNA',
  'SKLEP',
  'SPOLOCNY_PROSTOR',
  'JINE',
] as const;
export type UkonceniVRd = (typeof UKONCENI_V_RD_VALUES)[number];

export const UKONCENI_V_RD_LABELS: Record<UkonceniVRd, string> = {
  OBYTNY_PROSTOR: 'Obytný prostor',
  GARAZ: 'Garáž',
  SERVEROVNA: 'Serverovna',
  SKLEP: 'Sklep',
  SPOLOCNY_PROSTOR: 'Společný prostor',
  JINE: 'Jiné',
};

export function isUkonceniVRd(value: string | null | undefined): value is UkonceniVRd {
  return (UKONCENI_V_RD_VALUES as readonly string[]).includes((value ?? '').trim());
}

/** `JINE` requires free-text `ukonceni_v_rd_other`. */
export function ukonceniVRdRequiresOtherText(value: UkonceniVRd | string | null | undefined): boolean {
  return (value ?? '').trim() === 'JINE';
}

/**
 * PRIPOJENA — ukončení v RD je povinné při dokončení milníku **ZAVRTANY**.
 * Lineární záfuk / PHASE.2 (`isZafukPhaseTransitionValid`) ho nevyžaduje.
 */
export function requiresUkonceniVRdForZavrt(buildingType: string | null | undefined): boolean {
  return (buildingType ?? '').trim().toUpperCase() === 'PRIPOJENA';
}

/** @deprecated Use {@link requiresUkonceniVRdForZavrt} — ukončení v RD patří k závrtu, ne k záfuku. */
export const requiresUkonceniVRdForZafuk = requiresUkonceniVRdForZavrt;

export interface ZavrtMilestoneSpecFields {
  ukonceniVRd?: string | null;
  ukonceniVRdOther?: string | null;
}

/** Validace specifikace závrtů před dokončením milníku ZAVRTANY. */
export function isZavrtMilestoneSpecValid(
  buildingType: string | null | undefined,
  spec: ZavrtMilestoneSpecFields | null | undefined,
): boolean {
  if (!requiresUkonceniVRdForZavrt(buildingType)) return true;
  if (!spec) return false;
  return isUkonceniVRdSelectionValid(spec.ukonceniVRd, spec.ukonceniVRdOther);
}

export function isUkonceniVRdSelectionValid(
  value: string | null | undefined,
  other?: string | null,
): boolean {
  if (!isUkonceniVRd(value)) return false;
  if (ukonceniVRdRequiresOtherText(value)) return !!(other ?? '').trim();
  return true;
}

/** Český popisek pro UI / výkaz práce. */
export function formatUkonceniVRdLabel(
  value: string | null | undefined,
  other?: string | null,
): string {
  const v = (value ?? '').trim();
  if (!v) return '';
  if (isUkonceniVRd(v)) {
    const base = UKONCENI_V_RD_LABELS[v];
    if (ukonceniVRdRequiresOtherText(v)) {
      const o = (other ?? '').trim();
      return o ? `${base}: ${o}` : base;
    }
    return base;
  }
  return v;
}
